import { render, staticRenderFns } from "./ReporteGerencial.vue?vue&type=template&id=076afd68&scoped=true"
import script from "./ReporteGerencial.vue?vue&type=script&lang=js"
export * from "./ReporteGerencial.vue?vue&type=script&lang=js"
import style0 from "./ReporteGerencial.vue?vue&type=style&index=0&id=076afd68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076afd68",
  null
  
)

export default component.exports